import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components/ui/Header';
import { Footer } from './components/ui/Footer';
import { ThemeProvider } from './hooks/useTheme.tsx';
import { CartProvider } from './context/CartContext';
import { CartDrawer } from './components/ui/CartDrawer';
import { CheckoutModal } from './components/ui/CheckoutModal';
import HomePage from './pages/Home';
import CollectionsPage from './pages/Collections';
import CollectionPage from './pages/Collection';
import MyNFTsPage from './pages/MyNFTs';
import NFTDetailPage from './pages/NFTDetail';

function App() {
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  return (
    <ThemeProvider>
      <CartProvider>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/collections" element={<CollectionsPage />} />
              <Route path="/collection/:slug" element={<CollectionPage />} />
              <Route path="/my-collection" element={<MyNFTsPage />} />
              <Route path="/nft/:tokenAddress/:tokenId" element={<NFTDetailPage />} />
              {/* Redirects for old routes */}
              <Route path="/explore" element={<Navigate to="/" replace />} />
              <Route path="/sell" element={<Navigate to="/my-collection" replace />} />
              <Route path="/create" element={<Navigate to="/my-collection" replace />} />
              <Route path="/my-nfts" element={<Navigate to="/my-collection" replace />} />
            </Routes>
          </main>
          <Footer />
          <CartDrawer onCheckout={() => setCheckoutOpen(true)} hideWhenCheckoutOpen={checkoutOpen} />
          <CheckoutModal isOpen={checkoutOpen} onClose={() => setCheckoutOpen(false)} />
        </div>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
